import { Controller } from "@hotwired/stimulus"

/**
 * Prevents turbo:submit-end from bubbling up to the dynamic-modal controller,
 * which would otherwise close the modal after any form submission inside it.
 *
 * Usage: add BOTH attributes to any form inside a modal or sheet that should
 * NOT close it. Stimulus only binds an action once the named controller is
 * attached, so the action alone is silently inert:
 *   data-controller="prevent-modal-close"
 *   data-action="turbo:submit-end->prevent-modal-close#stop"
 */
export default class extends Controller {
  stop(event: Event) {
    event.stopPropagation()
  }
}
